import { DefaultCell } from "app/components/React/Table/cells/DefaultCell";
import { HeaderCellBold } from "app/components/React/Table/headerCells";
import { translate } from "app/filters/i18nFilter";
import type { FlexTableColumnType } from "app/pages/sales-intelligence/types";
import type TooltipTableColumn from "../../../models/view/signals-tooltip/TooltipTableColumn";

type Payload = Pick<FlexTableColumnType, "field" | "displayName"> &
    Partial<Pick<FlexTableColumnType, "cellComponent" | "headerComponent" | "format">> & {
        maxWidth?: number;
        minWidth?: number;
    };

export default function createSignalsTooltipTableColumn(payload: Payload): TooltipTableColumn {
    const {
        field,
        displayName,
        maxWidth = 160,
        format = "None",
        headerComponent = HeaderCellBold,
        cellComponent = DefaultCell,
    } = payload;

    return {
        field,
        displayName: displayName ?? translate(`si.signals.table-columns.tooltip.table.column.${field}`),
        headerComponent,
        cellComponent,
        maxWidth,
        type: "string",
        format,
    };
}
